import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getDefaultConfig, RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import { bsc, bscTestnet } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { http, fallback } from 'viem';
import '@rainbow-me/rainbowkit/styles.css';
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import InfoHub from "./pages/InfoHub";
import PostDetail from './pages/PostDetail';
import GalleryPage from './pages/GalleryPage';
import RewardsPage from "./pages/RewardsPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import ClubPage from "./pages/ClubPage";
import MarketPage from "./pages/MarketPage";
import OpenBoxPage from "./pages/OpenBoxPage";
import "antd/dist/reset.css";
import './styles/global-background.css';
import './App.css';
import useTwitterBindAutoClear from "./hooks/walletHooks";
import BridgePage from "./pages/BridgePage";
import BattlePredictionPage from "./pages/BattlePredictionPage";
import { 
  BSC_MAINNET_RPC_POOL, 
  BSC_TESTNET_RPC_POOL, 
  CURRENT_RPC_POOL, 
  ENVIRONMENT,
  NETWORK_CONFIG 
} from './contracts/config';

const projectId = 'YOUR_PROJECT_ID'; // 请替换为您的 WalletConnect Project ID

// 创建fallback传输配置
const createFallbackTransport = (rpcUrls: readonly string[]) => {
  return fallback(
    rpcUrls.map(url => 
      http(url, {
        timeout: 10000, // 10秒超时
        retryCount: 2,  // 重试2次
        retryDelay: 1000, // 重试延迟1秒
      })
    )
  );
};

// 根据环境选择支持的链
const supportedChains = ENVIRONMENT.isDev ? [bscTestnet] : [bsc];

const config = getDefaultConfig({
  appName: 'Novacrafter Lab',
  projectId,
  chains: supportedChains as any, // 临时解决类型问题
  transports: ENVIRONMENT.isDev ? {
    [bscTestnet.id]: createFallbackTransport(BSC_TESTNET_RPC_POOL), // 测试网使用fallback
  } : {
    [bsc.id]: createFallbackTransport(BSC_MAINNET_RPC_POOL), // 主网使用fallback
  },
});

// 配置QueryClient，添加重试机制
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5分钟
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});

const App: React.FC = () => {

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
            <Router>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/bridge" element={<BridgePage />} />
                <Route path="/clubs" element={<ClubPage />} />
                <Route path="/market" element={<MarketPage />} />
                <Route path="/hub" element={<InfoHub />} />
                <Route path="/rewards" element={<RewardsPage />} />
                <Route path="/post/:postId" element={<PostDetail />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/leaderboard" element={<LeaderboardPage />} />
                <Route path="/battle-prediction" element={<BattlePredictionPage />} />
                <Route path="/open-box" element={<OpenBoxPage />} />
              </Routes>
            </Router>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default App;
